/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomFieldReference,
    CustomFieldReferenceFromJSON,
    CustomFieldReferenceFromJSONTyped,
    CustomFieldReferenceToJSON,
    MediaRootPermission,
    MediaRootPermissionFromJSON,
    MediaRootPermissionFromJSONTyped,
    MediaRootPermissionToJSON,
    VolumeMiniReference,
    VolumeMiniReferenceFromJSON,
    VolumeMiniReferenceFromJSONTyped,
    VolumeMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaRoot
 */
export interface MediaRoot {
    /**
     * 
     * @type {number}
     * @memberof MediaRoot
     */
    id: number;
    /**
     * 
     * @type {Array<CustomFieldReference>}
     * @memberof MediaRoot
     */
    customFields?: Array<CustomFieldReference>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaRoot
     */
    workflow?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {VolumeMiniReference}
     * @memberof MediaRoot
     */
    volume: VolumeMiniReference;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    readonly fullPath: string;
    /**
     * 
     * @type {Array<MediaRootPermission>}
     * @memberof MediaRoot
     */
    readonly resolvedPermissions?: Array<MediaRootPermission>;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    needsRescan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    viewMode?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    viewStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    viewDefaultTab?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showCustomFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showRatings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showSubclips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showSubtitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showHistory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    showAiMetadata?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    prefetchThumbnailStrips?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    cover?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    nameField?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRoot
     */
    aiConfig?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRoot
     */
    shareComments?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaRoot
     */
    shareLinkDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaRoot
     */
    defaultProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRoot
     */
    cloudProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRoot
     */
    aiConnection?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRoot
     */
    aiProxyProfile?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRoot
     */
    proxyProfiles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRoot
     */
    jobs?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRoot
     */
    tags?: Array<number>;
}

export function MediaRootFromJSON(json: any): MediaRoot {
    return MediaRootFromJSONTyped(json, false);
}

export function MediaRootFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaRoot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customFields': !exists(json, 'custom_fields') ? undefined : ((json['custom_fields'] as Array<any>).map(CustomFieldReferenceFromJSON)),
        'workflow': !exists(json, 'workflow') ? undefined : json['workflow'],
        'volume': VolumeMiniReferenceFromJSON(json['volume']),
        'fullPath': json['full_path'],
        'resolvedPermissions': !exists(json, 'resolved_permissions') ? undefined : ((json['resolved_permissions'] as Array<any>).map(MediaRootPermissionFromJSON)),
        'name': json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'viewMode': !exists(json, 'view_mode') ? undefined : json['view_mode'],
        'viewStyle': !exists(json, 'view_style') ? undefined : json['view_style'],
        'viewDefaultTab': !exists(json, 'view_default_tab') ? undefined : json['view_default_tab'],
        'showTags': !exists(json, 'show_tags') ? undefined : json['show_tags'],
        'showComments': !exists(json, 'show_comments') ? undefined : json['show_comments'],
        'showLocations': !exists(json, 'show_locations') ? undefined : json['show_locations'],
        'showCustomFields': !exists(json, 'show_custom_fields') ? undefined : json['show_custom_fields'],
        'showRatings': !exists(json, 'show_ratings') ? undefined : json['show_ratings'],
        'showSubclips': !exists(json, 'show_subclips') ? undefined : json['show_subclips'],
        'showSubtitles': !exists(json, 'show_subtitles') ? undefined : json['show_subtitles'],
        'showMarkers': !exists(json, 'show_markers') ? undefined : json['show_markers'],
        'showHistory': !exists(json, 'show_history') ? undefined : json['show_history'],
        'showAiMetadata': !exists(json, 'show_ai_metadata') ? undefined : json['show_ai_metadata'],
        'prefetchThumbnailStrips': !exists(json, 'prefetch_thumbnail_strips') ? undefined : json['prefetch_thumbnail_strips'],
        'cover': !exists(json, 'cover') ? undefined : json['cover'],
        'nameField': !exists(json, 'name_field') ? undefined : json['name_field'],
        'aiConfig': !exists(json, 'ai_config') ? undefined : json['ai_config'],
        'shareComments': !exists(json, 'share_comments') ? undefined : json['share_comments'],
        'shareLinkDuration': !exists(json, 'share_link_duration') ? undefined : json['share_link_duration'],
        'defaultProxyProfile': !exists(json, 'default_proxy_profile') ? undefined : json['default_proxy_profile'],
        'cloudProxyProfile': !exists(json, 'cloud_proxy_profile') ? undefined : json['cloud_proxy_profile'],
        'aiConnection': !exists(json, 'ai_connection') ? undefined : json['ai_connection'],
        'aiProxyProfile': !exists(json, 'ai_proxy_profile') ? undefined : json['ai_proxy_profile'],
        'proxyProfiles': !exists(json, 'proxy_profiles') ? undefined : json['proxy_profiles'],
        'jobs': !exists(json, 'jobs') ? undefined : json['jobs'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
    };
}

export function MediaRootToJSON(value?: MediaRoot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'custom_fields': value.customFields === undefined ? undefined : ((value.customFields as Array<any>).map(CustomFieldReferenceToJSON)),
        'workflow': value.workflow,
        'volume': VolumeMiniReferenceToJSON(value.volume),
        'name': value.name,
        'path': value.path,
        'needs_rescan': value.needsRescan,
        'view_mode': value.viewMode,
        'view_style': value.viewStyle,
        'view_default_tab': value.viewDefaultTab,
        'show_tags': value.showTags,
        'show_comments': value.showComments,
        'show_locations': value.showLocations,
        'show_custom_fields': value.showCustomFields,
        'show_ratings': value.showRatings,
        'show_subclips': value.showSubclips,
        'show_subtitles': value.showSubtitles,
        'show_markers': value.showMarkers,
        'show_history': value.showHistory,
        'show_ai_metadata': value.showAiMetadata,
        'prefetch_thumbnail_strips': value.prefetchThumbnailStrips,
        'cover': value.cover,
        'name_field': value.nameField,
        'ai_config': value.aiConfig,
        'share_comments': value.shareComments,
        'share_link_duration': value.shareLinkDuration,
        'default_proxy_profile': value.defaultProxyProfile,
        'cloud_proxy_profile': value.cloudProxyProfile,
        'ai_connection': value.aiConnection,
        'ai_proxy_profile': value.aiProxyProfile,
        'proxy_profiles': value.proxyProfiles,
        'jobs': value.jobs,
        'tags': value.tags,
    };
}


